var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLokalisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.8617 0 0 3.86168 -6.615 -3.614)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4b4b4d",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    d: "M12.137 8.962A2.968 2.968 0 0010 8.092c-.93 0-1.632.374-2.136.87V5.849h4.273zm1.067 2.858v3.982l-2.373-1.99zM7.6 11.102h4.8L10 13.116zM10 14.51l2.302 1.934H7.698zm-3.204 1.295v-3.982l2.373 1.992zm11.49-4.959L15.157 4.96 10 1.51 4.866 4.973l-3.153 5.873 1.415.752.463-.873v6.784h12.817v-6.782l.464.871z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokalisation);
export default __webpack_public_path__ + "static/media/lokalisation.05699b98141e327c1680019bd439f911.svg";
export { ForwardRef as ReactComponent };